import { SET_REVIEWS_DATA } from "../actions/reviews-actions";

const reviewsInitialValue = {
  totalResults: 0,
  offset: 0,
  limit: 16,
  data: [],
};

const reviewsProductStatisticsInitialValue = {
  averageOverallRating: 0.0,
  totalReviewCount: 0,
  ratingDistribution: [],
  fitsRating: {
    range: 5,
    rating: 0,
  },
  features: [],
};

const initialState = {
  bvProdId: "",
  isFetchingReviews: true,
  results: reviewsInitialValue,
  reviewProductStatistics: reviewsProductStatisticsInitialValue,
};

const reviews = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REVIEWS_DATA:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reviews;
